<ng-container *transloco="let t;">

  <div class="p-mb-4" [ngClass]="{'card-disabled': disabled === true }">
    <p-card>
      <div class="p-grid">
        <div class="p-col-8">
          <h2>{{ t('common.labels.candidate') }}</h2>
        </div>
        <div class="p-col-4 p-text-right" *ngIf="inEdit === true">
          <button *ngIf="canEditCandidates() === true" (click)="addCandidate()" pButton type="button" [label]="t('common.labels.add')" icon="pi pi-plus" class="p-button-secondary p-button-sm p-button-outlined" [disabled]="!canAddCandidate() ? true : null"></button>
        </div>
      </div>

      <p-table [value]="candidates">
        <ng-template pTemplate="header">
            <tr>
              <th *ngIf="auth.isSuperUser()" pSortableColumn="id">{{ t('common.labels.id') }}
                  <p-sortIcon field="id"></p-sortIcon>
              </th>
              <th pSortableColumn="gender">{{ t('common.labels.salutation') }}
                  <p-sortIcon field="gender"></p-sortIcon>
              </th>
              <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
                  <p-sortIcon field="lastname"></p-sortIcon>
              </th>
              <th pSortableColumn="firstname">{{ t('common.labels.firstname') }}
                  <p-sortIcon field="firstname"></p-sortIcon>
              </th>
              <th pSortableColumn="mobile">{{ t('common.labels.mobile') }}
                  <p-sortIcon field="mobile"></p-sortIcon>
              </th>
              <th pSortableColumn="email">{{ t('common.labels.email') }}
                  <p-sortIcon field="email"></p-sortIcon>
              </th>
              <th>{{ t('common.labels.corporation') }}</th>
              <th>{{ t('common.labels.native_language') }}</th>
              <th>{{ t('common.labels.actual_function') }}</th>
              <th>{{ t('common.labels.recommendation') }}</th>
              <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-candidate>
            <tr>
              <td *ngIf="auth.isSuperUser()">{{ candidate.id | dashWhenEmpty }}</td>
              <td>{{ t(candidate.getSalutation()) | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.lastname | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.firstname | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.mobile | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.email | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ (candidate.getMisc('corporation')) ? t('common.labels.' + candidate.getMisc('corporation')) : '' | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.getMisc('native_language') | anonymizedCandidate | dashWhenEmpty }}</td>
              <td>{{ candidate.getMisc('actual_function') | anonymizedCandidate | dashWhenEmpty }}</td>
              <td><strong>{{ candidate.recommendation | anonymizedCandidate | dashWhenEmpty }}</strong></td>
              <td class="p-text-right" style="min-width: 120px;">
                <ng-container *ngIf="inEdit !== true && canResendEmail() === true">
                  <button withRight="admin.planning-orders.edit" pButton type="button" (click)="onResendInvitation(candidate)" icon="pi pi-envelope" [pTooltip]="t('ac_persons.resend_invitation')" tooltipPosition="left" class="p-button-outlined"></button>
                </ng-container>
                <ng-container *ngIf="inEdit === true && canEditCandidates() === true">
                  <button pButton (click)="editCandidate(candidate)" type="button" icon="pi pi-pencil" class="p-button-outlined p-ml-2" [disabled]="(submitting === true) ? true : null"></button>
                  <button pButton (click)="deleteCandidate(candidate)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="(submitting === true) ? true : null"></button>
                </ng-container>
                <ng-container *ngIf="inEdit !== true && canMoveCandidates() === true">
                  <button pButton (click)="openMoveDialog(candidate)" type="button" icon="pi pi-sign-out" class="p-button-outlined p-ml-2" [pTooltip]="t('ac_persons.move_to_other_ac')" tooltipPosition="left"></button>
                </ng-container>
                <ng-container *ngIf="inEdit !== true && auth.isSuperUser() === true && candidate.directlink">
                  <button pButton (click)="copyDirectLink(candidate)" type="button" icon="pi pi-reply" class="p-button-outlined p-ml-2" [pTooltip]="t('common.labels.copy_directlink')" tooltipPosition="left"></button>
                </ng-container>
              </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="10">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>

  <p-dialog [header]="t('common.labels.add_candidate')" [(visible)]="dialogVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <form (submit)="saveCandidate()">
      <div>
        <p class="p-text-right">
          <button type="button" pButton [label]="t('partials.employee_search.topline')" icon="pi pi-search" (click)="onOpenEmployeeSearch()" [disabled]="disabled" class="p-button-sm p-button-secondary p-button-outlined"></button>
        </p>

        <div class="p-grid">
          <div class="p-col-4">
            <app-form-control [cid]="'gender'" [control]="candidateForm.get('gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.gender')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'firstname'" [control]="candidateForm.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'lastname'" [control]="candidateForm.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'email'" [control]="candidateForm.get('email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'phone'" [control]="candidateForm.get('phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'mobile'" [control]="candidateForm.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'corporation'" [control]="candidateForm.get('corporation')" [type]="'select'" [options]="optionsCorporations" [label]="t('common.labels.corporation')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'native_language'" [control]="candidateForm.get('native_language')" [type]="'input'" [label]="t('common.labels.native_language')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'actual_function'" [control]="candidateForm.get('actual_function')" [type]="'input'" [label]="t('common.labels.actual_function')"></app-form-control>
          </div>
          <div class="p-col-4" *ngIf="boardDivisionVisible === true">
            <app-form-control [cid]="'board_division'" [control]="candidateForm.get('board_division')" [type]="'select'" [options]="options?.board_divisions" [label]="t('common.labels.board_division')"></app-form-control>
          </div>
        </div>

      </div>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelCandidate()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary p-mr-2"></button>
          <button pButton type="submit" label="{{ t('common.ok') }}" class="p-button-success"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>

  <app-ac-move-selector
    *ngIf="candiateToMove !== null"
    [candidate]="candiateToMove"
    [order]="order"
    (cancelled)="onMoveCancel()"
    (moved)="onMoveDone()"
  ></app-ac-move-selector>

</ng-container>
